import { useAtomValue, useSetAtom } from 'jotai';
import { useMemo } from 'react';

import { Dropdown } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';

import {
	registrationStateFilterAtom,
	updateRegistrationStateFilterAtom,
} from '../../atoms/preordersAtoms';
import { usePreordersFilterFacetCounts } from '../../hooks/usePreordersFilterFacetCounts';

/**
 * Filter section for registration state in the preorders filters drawer.
 * Uses a dropdown with dynamic facet counts from Algolia.
 */
export function FiltersDrawerStateSection(): React.ReactElement {
	const registrationState = useAtomValue(registrationStateFilterAtom);
	const setRegistrationState = useSetAtom(updateRegistrationStateFilterAtom);

	const { registrationStateCounts } = usePreordersFilterFacetCounts();

	const registrationStateOptions = useMemo(() => {
		return Object.entries(registrationStateCounts)
			.map(([state, count]) => ({
				id: state,
				label: `${state} (${count})`,
			}))
			.sort((a, b) => a.id.localeCompare(b.id));
	}, [registrationStateCounts]);

	return (
		<AccordionSection title='State'>
			<Dropdown
				label='Registration state'
				options={registrationStateOptions}
				value={registrationState}
				onSelectionChange={(value) => setRegistrationState(value || null)}
				placeholder='Select state'
			/>
		</AccordionSection>
	);
}
